import TrainingMatrix from "./TrainingMatrix.vue";

export default [{
    "path": "/Matrices/TrainingMatrix",
    "component": TrainingMatrix,
    "name": "Training Matrix",
    "meta": {
        "app": "Matrices",
        "sideNav": true,
        "name": "Training Matrix",
        "sideNavPosition": 12,
        "sideNavSection": "Staff Training",
        "appSwitcher": false,
        lock(user) {
            return [user?.Security?.General?.Training !== true, "Cannot view this area"];
        }
    }
}];
